"use strict";

var UserSelectorLoading = React.createClass({
  render: function() {
    return (
      <div className="userSelectorLoading">
        <div className="mb-10" >
          <input className="userSelectorLoading-search" disabled type="text"/>
        </div>
        <div>
          <label className="userSelectorLoading-user">
            <div>
              <div className="userSelectorLoading-userAvatar f-l"></div>
              <span className="userSelectorLoading-userName f-l"></span>
            </div>
            <div className="u-clear"></div>
          </label>
        </div>
      </div>
    );
  }
});

module.exports = UserSelectorLoading;



// WEBPACK FOOTER //
// ./app/shared/components/UserSelector/user-selector-loading.jsx